import { render, staticRenderFns } from "./ScenicspotAdd.vue?vue&type=template&id=09a12c90&scoped=true"
import script from "./ScenicspotAdd.vue?vue&type=script&lang=js"
export * from "./ScenicspotAdd.vue?vue&type=script&lang=js"
import style0 from "./ScenicspotAdd.vue?vue&type=style&index=0&id=09a12c90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a12c90",
  null
  
)

export default component.exports